import SvgIcon from "./LabLogoUploaded.svg?react";

export const LabLogoUploadedIcon = SvgIcon;
